import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { consentRequired, saveConsent, storedConsent, subscribeConsent } from "../../utils/consent.js";
import "./ConsentBanner.css";

// Shown to visitors in the UK, the EEA and Switzerland on the pages that load the
// analytics and ad tags (marketing pages, sign-in, sign-up) until they choose.
// Rejecting is as easy as accepting; the choice is kept in this browser.
export default function ConsentBanner() {
  const location = useLocation();
  const [choice, setChoice] = useState(() => storedConsent());
  useEffect(() => subscribeConsent(setChoice), []);

  const shell = typeof document !== "undefined" ? document.documentElement.getAttribute("data-route-shell") : null;
  const authPage = /(^|\/)(signin|signup)\/?$/.test(location.pathname || "");
  if ((shell !== "marketing" && !authPage) || choice || !consentRequired()) return null;

  return (
    <div className="offlico-consent" role="dialog" aria-live="polite" aria-label="Cookies">
      <p className="offlico-consent__text">
        We use cookies to measure visits to our website and how our ads perform. You can accept or reject them; the
        website works the same either way. <a href="/privacy/">Privacy policy</a>
      </p>
      <div className="offlico-consent__actions">
        <button type="button" className="offlico-consent__button" onClick={() => saveConsent("denied")}>
          Reject
        </button>
        <button
          type="button"
          className="offlico-consent__button offlico-consent__button--primary"
          onClick={() => saveConsent("granted")}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
